import React, { useState } from 'react';
import Bouton from '../../../../../UI/Bouton/Bouton';
import styles from './FormulaireYScale.module.scss';
import { BiSave } from 'react-icons/bi';
import * as type_btn from '../../../../../../ressources/glossaires/glossaire_type_de_bouton';

const FormulaireYScale = ({ value, onUpdate }) => {
  const [yScaleMin, setYScaleMin] = useState(value?.[0] ?? null);
  const [yScaleMax, setYScaleMax] = useState(value?.[1] ?? null);

  const handleMinChange = (event) => {
    setYScaleMin(event.target.value);
  };

  const handleMaxChange = (event) => {
    setYScaleMax(event.target.value);
  };

  const handleSubmit = () => {
    const min = yScaleMin ? parseFloat(yScaleMin) : null;
    const max = yScaleMax ? parseFloat(yScaleMax) : null;
    onUpdate([min, max]);
  };

  return (
    <span>
      <input
        className={styles.input}
        defaultValue={yScaleMin}
        placeholder="min"
        onChange={handleMinChange}
      />
      <input
        className={styles.input}
        defaultValue={yScaleMax}
        placeholder="max"
        onChange={handleMaxChange}
      />
      <Bouton
        ajoutClass={styles.btnn}
        type={type_btn.succes}
        cliquer={handleSubmit}
      >
        <BiSave size={20} />
      </Bouton>
    </span>
  );
};

export default FormulaireYScale;
